import { SearchX } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { NotificationSettingGroup } from "./NotificationSettingGroup";
import { filterSettingGroups, getSettingText, groupSettings } from "../setting-utils";
import type { NotificationSettingEntry, NotificationSettingGroupsProps } from "../types";

import EmptyState from "@/components/ui/v2/empty-state";
import SearchInput from "@/components/ui/v2/search-input";
import { useAuth } from "@/lib/hooks/useAuth";

export function NotificationSettingGroups({ settings }: NotificationSettingGroupsProps) {
  const { t } = useTranslation();
  const { context } = useAuth();
  const [query, setQuery] = useState("");
  const getText = (id: NotificationSettingEntry["id"]) => getSettingText(t, id, context);
  const groups = filterSettingGroups(groupSettings(settings), query, getText);

  return (
    <div className="flex flex-col gap-4">
      <div className="w-full max-w-md">
        <SearchInput
          placeholder={t("notificationSettings.searchPlaceholder")}
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
      </div>
      {groups.length === 0 ? (
        <div data-testid="notification-settings-no-results">
          <EmptyState
            icon={SearchX}
            title={t("notificationSettings.noResultsTitle")}
            description={t("notificationSettings.noResultsDescription")}
          />
        </div>
      ) : (
        groups.map((group) => <NotificationSettingGroup key={group.id} group={group} getText={getText} />)
      )}
    </div>
  );
}
